import { List, Record } from "immutable";

import { IS_BROWSER } from "@config/consts";

import { AVAILABLE_DIALING_CODES, TITLE_OPTS } from "@typings/globals";
import { FileAPIAccepted } from "@typings/fileUploading";

import { resolveCountryFromUrl } from "@services/ResolveCountryFromUrl";
import { getDialingCode } from "@services/GetDialingCode";

import { ApplyForm } from "./apply.typings";

export const applyFormDefaultState = {
  email: null,

  // personal info
  title: TITLE_OPTS.MS,
  firstName: "",
  lastName: "",
  phoneNumberPrefix: IS_BROWSER
    ? getDialingCode(resolveCountryFromUrl())
    : AVAILABLE_DIALING_CODES.CH,
  phoneNumber: "",
  streetAddress: "",
  zipCode: "",
  city: "",

  // experience info
  workPermitType: null,
  hoursPerWeek: null,
  yearsOfExperience: null,
  sourcesOfExperience: List(),
  methodOfCommuting: null,
  files: List(),
  howDidYouHearAboutUs: List(),
};

export const deleteApplicationFileFactory = (
  form: Record<ApplyForm>,
  fileToDeleteId: string,
): List<FileAPIAccepted> =>
  form.get("files").filter(file => file.id !== fileToDeleteId);
